import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import PaymentPreview from "./pages/Payment/PaymentPreview";
import PaymentResult from "./pages/Payment/PaymentResult";
import TransactionPreview from "./pages/Transaction/TransactionPreview";
import PageNotFound from "./pages/PageNotFound/PageNotFound";

function App() {
  return (
    <div className="App h-screen flex flex-col">
      <HashRouter>
        <Routes>
          {/* <Route path="/" element={<Navigate to="/t" />} /> */}
          <Route path="/" element={<PaymentPreview />} />
          <Route path="/payment-result" element={<PaymentResult />} />
          <Route path="/payment-error" element={<PaymentResult />} />
          <Route path="/response" element={<TransactionPreview />} />
          <Route path="*" element={<PageNotFound />}  />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default function AppWrapper() {
  return <App />;
}
